import {
  typologyKeys,
  formatKeys,
  inaugurationKeys,
  formatCategory,
  inaugrationCategory,
  typologyCategory,
  stateCategory,
  mapbp,
  practiceCategory,
  practiceKeys,
} from "./properties";
import { SpaceModel } from "./interfaces/Space";
import { Filters } from "./interfaces/Filters";
import { log } from "./debug";

const checkYear = (inaugFilters: string[], spcs: SpaceModel[]) => {
  const yearKeys = {
    "1980": "y80",
    "1990": "y90",
    "2000": "y00",
    "2010": "y10",
    "2020": "y20",
  };
  //if no filters used for years, just return list
  if (!inaugFilters || inaugFilters.length <= 0) {
    return spcs;
  }
  return spcs.filter((spc) => {
    const spaceInaug = spc.properties.inauguration;
    return inaugFilters.includes(
      yearKeys[`${spaceInaug}` as keyof typeof yearKeys]
    );
  });
};

//TODO: try to reduce the number of loops (filters, etc)
export const filterSpaces = (spaces: SpaceModel[], filters: Filters) => {
  const auxSpaces = [...spaces];
  const inaugFilters = filters.inauguration;
  let res: SpaceModel[] = auxSpaces;

  // filter spaces that are outside the bounds of the map
  // to avoid errors
  const bounds = mapbp.boundsExplicit;
  res = res.filter((s) => {
    return (
      s.coordinates[1] < bounds.maxLong &&
      s.coordinates[1] > bounds.minLong &&
      s.coordinates[0] < bounds.maxLat &&
      s.coordinates[0] > bounds.minLat
    );
  });

  if (inaugFilters) {
    res = checkYear(inaugFilters, auxSpaces);
  }

  //state
  const stateFilters = filters.state;
  if (stateFilters && stateFilters.length === 1) {
    res = res.filter((spc) => {
      if (stateFilters[0] === "open") {
        return spc.properties.open;
      } else {
        return !spc.properties.open;
      }
    });
  }

  //typology
  const typologyFilters = filters.typology;
  if (typologyFilters && typologyFilters.length > 0) {
    res = res.filter((spc) => {
      for (let i = 0; i < typologyFilters.length; i++) {
        if (spc.properties.typology.includes(typologyFilters[i])) {
          return true;
        }
      }
      return false;
    });
  }

  //format
  const formatFilters = filters.format;
  if (formatFilters && formatFilters.length > 0) {
    res = res.filter((spc) => {
      for (let i = 0; i < formatFilters.length; i++) {
        if (spc.properties.format.includes(formatFilters[i])) {
          return true;
        }
      }
      return false;
    });
  }

  //practice
  const practiceFilters = filters.practice;
  if (practiceFilters && practiceFilters.length > 0) {
    res = res.filter((spc) => {
      for (let i = 0; i < practiceFilters.length; i++) {
        if (spc.properties.practice.includes(practiceFilters[i])) {
          return true;
        }
      }
      return false;
    });
  }

  log(`filtered space list, size: ${res.length}`);

  return res;
};

export const convertFiltersToMapbox = (f: Filters) => {
  const resultFilters = [];

  const arrayToObject = (arr: any[] | undefined) => {
    if (!arr) {
      return [];
    }
    return arr.reduce((res, val) => {
      res[val] = true;
      return res;
    }, {});
  };

  const genList = [];

  //TODO: figure out if it's better to treat this as integer or string as it is...
  const inauguration = arrayToObject(f[inaugrationCategory]);
  if (inauguration["y80"]) genList.push(parseInt(inaugurationKeys.y80));
  if (inauguration["y90"]) genList.push(parseInt(inaugurationKeys.y90));
  if (inauguration["y00"]) genList.push(parseInt(inaugurationKeys.y00));
  if (inauguration["y10"]) genList.push(parseInt(inaugurationKeys.y10));
  if (inauguration["y20"]) genList.push(parseInt(inaugurationKeys.y20));

  if (genList.length > 0)
    resultFilters.push(["in", ["get", "inauguration"], ["literal", genList]]);

  //typology
  const typology = arrayToObject(f[typologyCategory]);
  const typologyExpressions = [];
  for (let key in typologyKeys) {
    if (typology[key]) {
      typologyExpressions.push(["in", key, ["get", "typology"]]);
    }
  }
  if (typologyExpressions.length > 0) {
    resultFilters.push(["any", ...typologyExpressions]);
  }

  //formats
  const format = arrayToObject(f[formatCategory]);
  const formatExpressions = [];
  for (let key in formatKeys) {
    if (format[key]) {
      formatExpressions.push(["in", key, ["get", "format"]]);
    }
  }
  if (formatExpressions.length > 0) {
    resultFilters.push(["any", ...formatExpressions]);
  }

  //practices
  const practice = arrayToObject(f[practiceCategory]);
  const practiceExpressions = [];
  for (let key in practiceKeys) {
    if (practice[key]) {
      practiceExpressions.push(["in", key, ["get", "practice"]]);
    }
  }
  if (practiceExpressions.length > 0) {
    resultFilters.push(["any", ...practiceExpressions]);
  }

  //state filters
  const state = arrayToObject(f[stateCategory]);
  if (state["open"] !== state["closed"]) {
    if (state["open"]) resultFilters.push(["==", ["get", "open"], true]);
    else resultFilters.push(["==", ["get", "open"], false]);
  }

  return resultFilters.length > 0 ? ["all", ...resultFilters] : [];
};


export function debounce<T extends (...args: any[]) => void>(func: T, wait: number) {
  let timeout: ReturnType<typeof setTimeout> | null;
  return function (...args: Parameters<T>) {
      if (timeout) {
          clearTimeout(timeout);
      }
      timeout = setTimeout(() => func(...args), wait);
  };
}
